import { useEffect, useState } from "react";
import SkeletonImage from "../../Skeleton/skeleton-image-component";
import { Modal } from "../../Modal/modal-component";
import useClickOutside from "../../../Hooks/useClickOutside";

function ImageGrid(params) {
    const adapter = params.adapter;
    const [selected, setSelected] = useState(null);
    const [isLoaded, setIsLoaded] = useState(adapter?.useSkeleton || false);
    const [chunkedImages, setChunkedImages] = useState([]);
    const [skeletonLoad, setSkeletonLoad] = useState([]);

    useEffect(() => {
        setIsLoaded(adapter?.useSkeleton || false);
        const elements = adapter?.elements;
        const skeletonArray = [];
        const imagesArray = [];

        for (let i = 0; i < 6; i += 3) {
            skeletonArray.push([i, i + 1]);
        }
        setSkeletonLoad(skeletonArray);

        if (elements === undefined || elements.length === 0) {
            setChunkedImages(undefined);
        } else {
            for (let i = 0; i < elements.length; i += 3) {
                imagesArray.push(elements.slice(i, i + 3));
            }
            setChunkedImages(imagesArray);
        }
    }, [adapter]);


    const handleSelect = (item) => {
        setSelected(item);
        adapter.trigger(item);
    };

    setTimeout(() => { setIsLoaded(true); }, 2000)


    return (
        <div>
            <div className="grid grid-cols-2  gap-4">
                {
                    !isLoaded || chunkedImages === undefined || chunkedImages.length === 0 ? skeletonLoad.map((chunk, index) => (
                        <div key={index} className="grid gap-4">
                            {chunk.map((item, id) => (
                                <div
                                    key={id}
                                    className={`relative grid gap-4 transition-all duration-200 hover:bg-gray-800 rounded-lg cursor-pointer  ${selected && selected.id === item.id ? "shadow-2xl border border-blue-800" : ""}`}>
                                    <div>
                                        <SkeletonImage />
                                    </div>
                                </div>
                            ))}
                        </div>
                    )) :
                        chunkedImages.length < 8 ? adapter.elements.map((item, id) =>
                            <div
                                key={item.id}
                                className={`relative flex gap-4 transition-all duration-200 hover:bg-gray-800 rounded-lg cursor-pointer ${selected && selected.id === item.id ? "shadow-2xl " : ""}`}
                                onClick={() => handleSelect(item)}>
                                <div>
                                    <img
                                        className="h-auto max-w-full rounded-lg"
                                        src={item.image}
                                        alt={item.title}
                                    />
                                </div>
                                <div className="absolute top-0 left-0 w-full h-full opacity-0 transition-opacity duration-200 hover:opacity-100 rounded-lg bg-black bg-opacity-25 ">
                                    <div className="flex justify-between items-center px-4 py-2 flex-col my-2">
                                        {/* <span className="text-white font-bold">{item.title}</span> */}
                                        <div className="absolute bottom-2 right-2 items-center gap-2">
                                            <div className="flex flex-row"> 
                                                <div className={`text-sm font-bold text-white mx-2 transition-all ease-in-out duration-200 ${selected && selected.id === item.id ? "opacity-100": "opacity-0"}`}>{item.title} </div>
                                                <button type="button" className="relative px-1/2 py-1/2 rounded-full bg-white font-bold text-white hover:scale-125 transition-all ease-in-out focus:outline-none duration-300 ">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="black" className="w-6 h-6">
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        ) :
                            <div className="md:grid-cols-4">
                                {
                                    chunkedImages.map((chunk, index) => (
                                        <div key={index} className="grid gap-4">
                                            {chunk.map((item) => (
                                                <div
                                                    key={item.id}
                                                    className={`relative grid gap-4 transition-all duration-200 hover:bg-gray-800 rounded-lg cursor-pointer ${selected && selected.id === item.id ? "shadow-2xl border border-blue-800" : ""}`}
                                                    onClick={() => handleSelect(item)}>
                                                    <div>
                                                        <img
                                                            className="h-auto max-w-full rounded-lg"
                                                            src={item.image}
                                                            alt={item.title}
                                                        />
                                                    </div>
                                                    <div className="absolute top-0 left-0 w-full h-full opacity-0 transition-opacity duration-200 hover:opacity-100 rounded-lg bg-black bg-opacity-25 ">
                                                        <div className="flex justify-between items-center px-4 py-2 flex-col my-2">
                                                            <span className="text-white font-bold">{item.title}</span>
                                                            <div className="flex items-center gap-2">
                                                                <button type="button" className="px-2 py-1 rounded-lg bg-blue-500 font-bold text-white hover:bg-blue-600 focus:outline-none transition-all duration-200 ">
                                                                    Save
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ))
                                }
                            </div>
                }
            </div>
        </div>
    );
}

export default ImageGrid;
